const descriptions = {
  headingTitle: {
    id: 'course-authoring.textbooks.header.title',
    defaultMessage: 'Libros de texto',
    description: 'Title for the textbooks section',
  },
  breadcrumbContent: {
    id: 'course-authoring.textbooks.header.breadcrumb.content',
    defaultMessage: 'Contenido',
    description: 'Breadcrumb for content',
  },
  breadcrumbPagesAndResources: {
    id: 'course-authoring.textbooks.header.breadcrumb.pages-and-resources',
    defaultMessage: 'Páginas y Recursos',
    description: 'Breadcrumb for pages and resources',
  },
  breadcrumbAriaLabel: {
    id: 'course-authoring.textbooks.header.breadcrumb.aria-label',
    defaultMessage: 'Migas de pan del libro de texto',
    description: 'Aria label for the textbook breadcrumb',
  },
  newTextbookButton: {
    id: 'course-authoring.textbooks.header.new-textbook',
    defaultMessage: 'Nuevo libro de texto',
    description: 'Text for the button to create a new textbook',
  },
};

export default descriptions;
